export const SET_WC_COUNTRIES = 'SET_WC_COUNTRIES';
export const TOGGLE_WC_COUNTRY_FAVORITE = 'TOGGLE_WC_COUNTRY_FAVORITE';
export const SET_WC_VIEW_FILTER = 'SET_WC_VIEW_FILTER';
export const SET_WC_LETTER_FILTER = 'SET_WC_LETTER_FILTER';

const initialState = {
  countries: [],
  loaded: false,
  viewFilter: 'all',
  letterFilter: 'all',
};

export const setWCCountries = countries => ({
  type: SET_WC_COUNTRIES,
  payload: countries,
});

export const toggleWCCountryFavorite = countryId => ({
  type: TOGGLE_WC_COUNTRY_FAVORITE,
  payload: countryId,
});

export const setWCViewFilter = viewFilter => ({
  type: SET_WC_VIEW_FILTER,
  payload: viewFilter,
});

export const setWCLetterFilter = letterFilter => ({
  type: SET_WC_LETTER_FILTER,
  payload: letterFilter,
});

export default function wcCountries(state = initialState, action) {
  switch (action.type) {
    case SET_WC_COUNTRIES:
      return {
        ...state,
        countries: action.payload,
        loaded: true,
      };

    case TOGGLE_WC_COUNTRY_FAVORITE:
      return {
        ...state,
        countries: state.countries.map(country =>
          country.id === action.payload
            ? { ...country, favorite: !country.favorite }
            : country,
        ),
      };

    case SET_WC_VIEW_FILTER:
      return {
        ...state,
        viewFilter: action.payload,
      };

    case SET_WC_LETTER_FILTER:
      return {
        ...state,
        letterFilter: action.payload,
      };

    default:
      return state;
  }
}
